import { Badge } from "@/components/ui/badge";

const statusLabels: Record<string, string> = {
  draft: "Draft",
  active: "Active",
  archived: "Archived",
};

const statusStyles: Record<string, string> = {
  draft: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
  active: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  archived: "bg-zinc-500/10 text-zinc-600 dark:text-zinc-400",
};

interface StatusBadgeProps {
  status: string;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const label = statusLabels[status] ?? status;

  return (
    <Badge variant="outline" className={`border-transparent ${statusStyles[status] ?? ""}`}>
      {label}
    </Badge>
  );
}
